import { render, staticRenderFns } from "./WebSwiper.vue?vue&type=template&id=8915c614&scoped=true&"
import script from "./WebSwiper.vue?vue&type=script&lang=ts&"
export * from "./WebSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./WebSwiper.vue?vue&type=style&index=0&id=8915c614&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8915c614",
  null
  
)

export default component.exports